export default "__VITE_ASSET__CMtvhHxP__"